import React from 'react';
import { RefinementList } from 'react-instantsearch';
import sortBy from 'lodash.sortby';

import FilterBlock from '../../elements/FilterBlock';
import { useScreenMinLg } from '@hooks/useResponsive';

const transformItems = items => sortBy(items, ['label']);

const ArticleFilters = () => {
    const isScreenMinLg = useScreenMinLg();

    return (
        <>
            <FilterBlock label="Article Type" defaultExpanded={isScreenMinLg}>
                <RefinementList attribute="article_types" limit={99999} transformItems={transformItems} />
            </FilterBlock>

            <FilterBlock label="Topic">
                <RefinementList attribute="topics" limit={99999} transformItems={transformItems} />
            </FilterBlock>
        </>
    );
};

export default ArticleFilters;
